import type { RootState } from '..';
import { isOidcAuth } from '../../config/featureFlags';

export const selectAuthUser = (state: RootState) => state.auth.user;

export const selectIsPlatformAdmin = (state: RootState) =>
  state.auth.user?.role === 'ADMIN';

export const selectIsSuperAdmin = (state: RootState) =>
  state.auth.user?.role === 'SUPER_ADMIN';

export const selectIsUserRole = (state: RootState) =>
  state.auth.user?.role === 'USER';

/**
 * True when the signed-in user resolves to no usable organization. The
 * organization only travels in the OIDC token, so local auth never applies.
 * A superadmin is global by design and has no organization.
 */
export const selectHasNoOrganization = (state: RootState) => {
  const user = state.auth.user;

  if (!isOidcAuth() || !state.auth.isAuthenticated || !user) return false;
  // Load-bearing, not redundant: orgSlug is null for a SUPER_ADMIN by contract,
  // so removing this line locks out every platform staff account.
  if (user.role === 'SUPER_ADMIN') return false;

  // Post-claim-parse these two are equivalent for a non-superadmin — role and
  // slug come from the same path — so this is belt-and-braces, not two
  // independent checks.
  return !user.role || !user.orgSlug;
};
